<div>
  <div class="label">
    {{leftLabel}} <span class="pull-right" role="alert" [attr.aria-label]="ariaLabel"> {{rightLabel}} </span>
  </div>
  <div class="progress">
    <div *ngFor="let d of data; let i = index;" class="progress-bar" [ngStyle]="calcProgress(d,i)"></div>
    <div *ngIf="data && data.length == 0" class="progress-bar default"></div>
  </div>
</div>
